import { render, staticRenderFns } from "./forumTopic.vue?vue&type=template&id=73b22124&"
import script from "./forumTopic.vue?vue&type=script&lang=js&"
export * from "./forumTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports